import { useEffect, useContext } from "react";
import { contexto } from "./CustomProvider";
import { isProduction } from "./utils";

const KeepAlive = () => {
    const { thisDeviceData, usuarioContexto } = useContext(contexto);
    const uid = usuarioContexto?.uid;
    const deviceId = thisDeviceData?.deviceId;

    useEffect(() => {
        // ⛔ Si falta algo clave, no hacer nada
        if (!uid || !deviceId) return;

        //En LOCALHOST NO hacemos keep alive
        if (!isProduction()) return;

        const keepAlive = () => {
            const urlKeepAlive = `https://rai-backend-production.up.railway.app/cajaboba/usuariosactivos/${uid}/${deviceId}`;

            fetch(urlKeepAlive, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    vecesIniciado: (thisDeviceData?.vecesIniciado ?? 0) + 1
                })
            }).catch(error => {
                console.error('Error en keepAlive:', error);
            });
        };

        // primer ping a los 10 segundos
        const timeoutId = setTimeout(keepAlive, 10 * 1000);

        // luego cada 1 minuto
        const intervalId = setInterval(keepAlive, 60 * 1000);

        return () => {
            clearTimeout(timeoutId);
            clearInterval(intervalId);
        };
    }, [uid, deviceId, thisDeviceData?.vecesIniciado]);

    return null;
};

export default KeepAlive;